import { Card, Typography } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import { default as React, useState } from 'react';
import { useTranslate } from 'react-admin';
import InfoTooltipIcon from '../../../assets/InfoTooltipIcon';
import globalUseStyles from '../../../styles/globalCustomStyles';
import CustomTooltip from '../../aegeon/CustomTooltip';
import TimeseriesField from "../../aegeon/timeseries/TimeseriesField";

import PotentialGainCard from '../../devices/Cards/PotentialGainCard';
import ParametersPotentialGainComponent from '../../devices/CustomButtons/ParametersPotentialGainComponent';

const PotentialGainDeviceDetails = (props) => {
  const globalClasses = globalUseStyles();
  const t = useTranslate();

  const moment = require('moment');
  const startDate = moment().set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).subtract(1, 'months').startOf('month');
  const endDate = moment().set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).subtract(1, 'months').endOf('month');

  const initialParameters = {
    daysOfWeek: {
      0: true,
      1: true,
      2: true,
      3: true,
      4: true,
      5: false,
      6: false,
    },
    hoursRange: [8, 18],
    centile: 0.1,
    period: [startDate, endDate],
    publicHolidays: false,
  };
  const [parameters, setParameters] = useState({ daysOfWeek: initialParameters.daysOfWeek, hoursRange: initialParameters.hoursRange, centile: initialParameters.centile, period: initialParameters.period, publicHolidays: initialParameters.publicHolidays });

  const setParametersBack = (daysOfWeek, hoursRange, centile, period, publicHolidays) => {
    setParameters({ daysOfWeek: daysOfWeek, hoursRange: hoursRange, centile: centile, period: period, publicHolidays: publicHolidays });
  }

  return (

    <Grid2 item="true" small={12} medium={12} big={12} key="3">
      <Card className={globalClasses.DetailCard}>
        <div className={globalClasses.DetailCardTableTitle}>
          <Typography variant="h8">{t('devices.analyse.potential_gain.title')}</Typography>
          {<CustomTooltip title={t('devices.analyse.potential_gain.tooltip_text')} icon={<InfoTooltipIcon />} />}
        </div>
        <div className={globalClasses.DetailCardTableSubtitle}>
          {t('devices.analyse.potential_gain.subtitle')}
        </div>
        <div>
          <ParametersPotentialGainComponent setParametersBack={setParametersBack} initialParameters={initialParameters} />
          <TimeseriesField source="active_power" filter={{ startDate: parameters.period[0], endDate: parameters.period[1] }} aggregation={{ period: "HOUR", operation: "IN_KWH" }}>
            <div style={{ width: "100%", height: "550px" }} >
              <PotentialGainCard parameters={parameters} />
            </div>
          </TimeseriesField>
        </div>
      </Card>
    </Grid2>
  )
};

export default PotentialGainDeviceDetails;

